import React from 'react';
import AgentMessageContent from './agentMessageContent';
import { QuickReplyOption, quickReplySendValue } from './quickReplyUtils';

interface MessageBubbleProps {
  role: 'user' | 'assistant';
  content: string;
  quickReplies?: Array<string | QuickReplyOption>;
  images?: string[];
  onQuickReply?: (value: string) => void;
}

function Avatar() {
  return (
    <div style={{
      width: 28,
      height: 28,
      borderRadius: '50%',
      flexShrink: 0,
      background: 'linear-gradient(135deg, #3a3530 0%, #6b5f54 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 11,
      fontWeight: 600,
      color: '#e8e2da',
      marginTop: 2,
    }}>H</div>
  );
}

export default function MessageBubble({ role, content, quickReplies, images, onQuickReply }: MessageBubbleProps) {
  const isUser = role === 'user';
  const hasImages = !!images && images.length > 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: isUser ? 'flex-end' : 'flex-start', marginBottom: 14 }}>
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        maxWidth: '88%',
        flexDirection: isUser ? 'row-reverse' : 'row',
      }}>
        {!isUser && <Avatar />}
        <div style={{
          minWidth: 0,
          padding: '10px 14px',
          borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
          background: isUser ? '#2d2925' : '#f4f0eb',
          color: isUser ? '#f5f2ee' : '#2d2925',
          fontSize: 14,
          lineHeight: 1.55,
          whiteSpace: 'pre-wrap',
          overflowWrap: 'anywhere',
        }}>
          {hasImages && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: images!.length === 1 ? '1fr' : 'repeat(2, 1fr)',
              gap: 6,
              marginBottom: content ? 8 : 0,
            }}>
              {images!.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Shared hair photo ${index + 1}`}
                  style={{
                    display: 'block',
                    width: '100%',
                    maxHeight: images!.length === 1 ? 220 : 120,
                    objectFit: 'cover',
                    borderRadius: 12,
                  }}
                />
              ))}
            </div>
          )}
          {content && (
            isUser ? content : <AgentMessageContent content={content} quickReplies={quickReplies} />
          )}
        </div>
      </div>

      {quickReplies && quickReplies.length > 0 && onQuickReply && (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 6,
          marginTop: 8,
          marginLeft: isUser ? 0 : 36,
          justifyContent: isUser ? 'flex-end' : 'flex-start',
        }}>
          {quickReplies.map((qr, index) => {
            const option = typeof qr === 'string'
              ? { display: qr, value: qr }
              : qr;
            const key = `${option.value}-${index}`;
            return (
            <button
              key={key}
              onClick={() => onQuickReply(quickReplySendValue(qr))}
              style={{
                padding: '6px 14px',
                borderRadius: 20,
                border: '1.5px solid #d4cec8',
                background: '#fff',
                color: '#3a3530',
                fontSize: 13,
                fontWeight: 500,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              {option.display}
            </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
